var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortDesc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.13v89.043h534.258v-89.043h-534.258zM756.869 11.13v831.998l-115.481-115.481-62.606 62.609 190.609 192.002 31.999 30.61 31.999-30.61 190.612-192.002-62.609-62.609-115.481 115.481v-831.998h-89.042zM0 278.26v-89.044h445.216v89.044h-445.216zM0 367.303v89.043h356.173v-89.043h-356.173zM0 634.433v-89.044h267.13v89.044h-267.13zM0 723.477v89.042h178.086v-89.042h-178.086zM0 990.603v-89.042h89.043v89.042h-89.043z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDesc);
export default __webpack_public_path__ + "static/media/sort-desc.b2df48d5538eec8a69b8d1b2b7b8c24e.svg";
export { ForwardRef as ReactComponent };